<template>
  <article class="pi-activity" :class=" divShow ? 'opacity-show':'opacity-hide'" v-if="app.activityShow">
    <div class="pi-activity-content">
      
      <div class="pi-activity-info">
        <div class="pi-activity-header-img">
          <img src="../../assets/image/coupon-bg.png" alt="">
        </div>
        <div class="content-title" v-if="couponListObj[0]">{{couponListObj[0].campaignTitle}}</div>
        <!-- <div class="condition">充值满60赠送</div> -->
        <div class="coupon-list-box">
          <div class="coupon-list-header"></div>
          <ul class="coupon-list">
            <!-- app.activityList -->
            <pi-coupon-item :status="1" size="small"
                v-for="(item, index) in couponListObj"
                :item="item"
                @go="close"
                :key="index"></pi-coupon-item>
          </ul>
        </div>
        <div class="activity-btn">已放入您的卡包</div>
      </div>
      <div class="activity-close" @click="showBox">
        <img src="../../assets/image/close.png" />
      </div>
    </div>
  </article>
</template>
<script>
import couponeItem from "@/view/my-coupon/components/coupon-item";
import { mapState,mapMutations } from "vuex";
import {getHasBeenRead,readCoupon} from '@/common/api/index'
// import { clearTimeout, setInterval } from 'timers';
export default {
  name: 'pi-activity',
  components: {
    [couponeItem.name]: couponeItem,
  },
  data(){
    return{
      couponListObj: [],
      couponPkIds: [],
      activityShow: true,
      divShow: true,
      activityObj: {}, // 后台返回了几个活动
      showActivityId: '', // 当前显示的活动
      timer: null
    }
  },
  computed: {
    ...mapState(["app"]),
  },
  
  methods: {
    getList(){
      if(this.app.userInfo){
        getHasBeenRead({},false).then(ret=>{
          if (ret.status === this.$config.ajaxStatus && ret.data) {
            if(ret.data.length > 0){
              
              let activityObj = {}; //当前列表有几次活动
              let couponPkIds = [];
              ret.data.map(item=>{
                if(!item.hasBeenRead){
                  if(!activityObj[item.campaignPkId]){
                    activityObj[item.campaignPkId] = {
                      show: false,
                      list: []
                    };
                  }
                  item.rule = item.templates[0] || {};
                  activityObj[item.campaignPkId].list.push(item);
                  couponPkIds.push(item.campaignPkId);
                }
              })
              this.activityObj = activityObj;
              this.couponPkIds = couponPkIds;
              this.showBox();
              // let couponListObj = [];
              // let couponPkIds = [];
              // ret.data.map(item=>{
              //   if(!item.hasBeenRead){
              //     couponListObj.push(item);
              //     item.rule = item.templates[0] || {};
              //     couponPkIds.push(item.couponTemplatePkId);
              //   }
              // })
              // this.couponListObj = couponListObj;
              // this.couponPkIds = couponPkIds;
              // if(this.couponListObj.length > 0){
              //   this.SET_ACTIVITYSHOW(true);
              //   //然后请求阅读
              //   this.readCoupon();
              // }
              
            }
          }
          
        })
      }
    },
    showBox(){
      let showActivityId = '';
      for(let i in this.activityObj){
        if(this.activityObj[i].show == false){
          showActivityId = i;
          this.activityObj[i].show = true;
          break;
        }
      }
      // 找出一个没看过的活动
      if(showActivityId != ''){
        console.log(this.timer)
        this.divShow = true;
        clearTimeout(this.timer);
        this.couponListObj = this.activityObj[showActivityId].list;
        this.readCoupon(showActivityId);
        this.SET_ACTIVITYSHOW(true);
        
      }else{
        // 如果都看了就直接关闭
        this.close();
      }
      
      this.showActivityId = showActivityId;
    },
    readCoupon(campaignPkId){
      readCoupon({
        campaignPkId: campaignPkId
      }).then(ret=>{
        if (ret.status === this.$config.ajaxStatus) {
          console.log("阅读成功")
        }
      })
    },
    close(){
      this.divShow = false;
      this.activityObj = {};
      this.showActivityId = '';
      setTimeout(()=>{
        this.SET_ACTIVITYSHOW(false);
      },500)
      clearTimeout(this.timer);
      this.timer =  setInterval(()=>{
        this.getList();
      },3 * 60 *  1000)
    },
    ...mapMutations([ "SET_ACTIVITYSHOW"])
  },
  mounted() {
    this.getList();
    this.timer =  setInterval(()=>{
      this.getList();
    },3 * 60 *  1000)
    
  },
}
</script>
<style lang="less">
  .pi-activity{
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index:99999;
    background: rgba(0,0,0,0.5);
    box-sizing: border-box;
    padding: 0.2rem 0.23rem;
    .pi-activity-content{
      padding: 1.07rem 0.17rem 0 0.17rem;
      position: relative;
      .pi-activity-header-img{
        height: 3.12rem;
        position: absolute;
        left:0;
        top: 0;
        z-index: 3;
        img{
          width: 100%;
          height: 100%;
        }
      }
      .pi-activity-info{
        background: linear-gradient(180deg, #FFA244 0%, #F74754 43%, #DB3036 100%);
        box-shadow: 0px -0.1rem 0.1rem 0px #C11B05;
        border-radius: 0.1rem;
        padding-top: 0.3rem;
        padding-bottom: 0.4rem;
        .content-title{
          font-size: 0.6rem;
          line-height: 0.84rem;
          text-align: center;
          color: #fff;
          position: relative;
          z-index: 10;
        }
        .condition{
          font-size: 0.34rem;
          line-height: 0.48rem;
          text-align: center;
          color: #fff;
          margin-top: 0.1rem;
          position: relative;
          z-index: 10;
        }
        .coupon-list-box{
           margin: 0.2rem 0.35rem 0 0.35rem;
          .coupon-list-header{
            height: 0.12rem;
            border-radius: 0.1rem;
            background-color: #C11B05;
          }
        }
        .coupon-list{
          background-color: #FFEFB7;
          margin: -0.06rem 0.12rem 0 0.12rem;
          padding: 0.2rem;
          max-height: 3.66rem;
          overflow: auto;
          -webkit-overflow-scrolling: touch;
        }
      }
      .activity-btn{
        margin: 0.4rem 1rem;
        height: 0.94rem;
        line-height: 0.94rem;
        text-align: center;
        background: #FEE21F;
        box-shadow: 0px 0px 0.06rem 0.04rem #E2C814;
        border-radius: 0.47rem;
        color: #DB3036;
        font-size:0.36rem;
      }
    }
    .activity-close{
      margin-top: 0.6rem;
      text-align: center;
      img{
        width:0.7rem;
        height: 0.7rem;
        vertical-align: top;
      }
    }
  }
</style>